import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

import { VideoShareDialogService } from './video-share-dialog.service';

export const ngxVideoShareDialogServiceModule = angular.module('ngxVideoShareDialogServiceModule', [])
	.factory('ngxVideoShareDialogService', downgradeInjectable(VideoShareDialogService) as any)
	.name;
